export const customerSuccessKeys = {
  base: ["customer-success"] as const,
  cseList: () => [...customerSuccessKeys.base, "executives"] as const,
  csmList: () => [...customerSuccessKeys.base, "managers"] as const,
} as const;
